/**
 * Filter and re-map attribute names
 */
import Utils = require("../utils");
import Base = require("./base-command");
import _ = require("underscore");
import globals = require("../../globals");

class Command extends Base<{in: any, out: {layers: any}}> {

    static about = `
    Filter and re-map attribute names

Usage Example:

\`\`\`xml
<COMMAND about="Simple attribute renaming to present addresses in with known attribute names" id="address-view-model" mid="app/commands/view-model" type="action">
<OPTIONS>
  <Values about="Identify the attribute names to be mapped" id="from" value="OWNER,STRNO,&lt;%=STRDIR&gt; &lt;%=STRNAME&gt;,CITY,STATE,ZIP" />
  <Values about="Identifies an attribute name for each from mapping" id="to" value="owner, streetNumber, streetName, city, state, zip" />
</OPTIONS>
</COMMAND>
\`\`\`

`;

    static options = {
        "in": {
            "required": true,
            "about": "restrict results to this subset of field names"
        },
        "out": {
            "required": true,
            "about": "for each in field name an out alias field name is required"
        },
        "layers": {
            "required": true,
            "about": "contains field names, field aliases and features, the array of models to be transform"
        }
    }

    static output = {
        "view-model": {
            "about": "the resulting models",
        },
    }

    execute(args = this.args) {

        let options = this.asOptions(Command.options);
        let inFields = Utils.split(options.in);
        let outFields = Utils.split(options.out);
        console.assert(inFields.length == outFields.length, "field length mismatch");

        let layers = <Array<Rhythm.GIS.FeatureQueryResultLayer>>this.findOption("layers");
        console.assert(!!layers, "layers expected");
        console.assert(Array.isArray(layers), "layers is a collection");

        console.assert(1 === layers.length, "expecting exactly one layer");
        console.assert(Array.isArray(layers[0].features), "first layer has features");

        let layer = layers[0];

        // pre-compute the templates
        let fieldTemplates = inFields.map(f => _.template(Utils.template(f)));

        layer.features.forEach(v => {
            for (let fieldIndex = 0; fieldIndex < fieldTemplates.length; fieldIndex++) {
                // apply pre-computed template
                let targetValue = fieldTemplates[fieldIndex](v.attributes);
                let targetName = outFields[fieldIndex];
                if (targetValue !== null && targetValue !== undefined) {
                    // TODO: doesn't consider order of ops, if value exists, etc..
                    v.attributes[targetName] = targetValue;
                }
            }
        });

        // do not put a new layer out there since the actual data is being modified
        this.trigger(args.out);
    }

}

export = Command; 